import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'nairaCurrency'
})
export class NairaCurrencyPipe implements PipeTransform {
  transform(value: number | string | null | undefined ): string {

    const numericValue = typeof value === 'string' ? parseFloat(value) : value;

    if (numericValue === null || numericValue === undefined || isNaN(numericValue)) {
      return ''; // Handle cases where value is not a valid number
    }

    // Format the valid number with the Naira sign and two decimal places
    return '₦ ' + numericValue.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
  }
}
